import { compose } from 'recompose';
import TotalTimeList from './totalTimeList';

const enhance = compose();
export default enhance(TotalTimeList);
